// Helper functions
export const generateSpannedWordMessage = (message?: string) => {
  if (!message) return ""

  const words = message.split(" ")
  const wordsWithSpans = words.map((word) => `<span>${word}</span>`)
  const spannedString = wordsWithSpans.join(" ").trim()

  return spannedString
}

export const autoScrollMessagesList = (scrollableEl: HTMLDivElement | null) => {
  if (!scrollableEl) return

  const scrollableStyles = window.getComputedStyle(scrollableEl).transform
  const scrollableMatrix = new WebKitCSSMatrix(scrollableStyles)
  const scrollableYPos = scrollableMatrix.m42

  // Translate the scrollableEl to the top using the message's top position
  scrollableEl.style.transform = `translateY(${scrollableYPos - 105}px)`
}

export const resetScrollMessagesList = (
  scrollableEl: HTMLDivElement | null,
) => {
  if (!scrollableEl) return

  scrollableEl.style.transform = "translateY(0px)"
}

export const resetAgentsAnim = (
  orbsContainerEl: HTMLDivElement | null,
  agentsContainerEl: HTMLDivElement | null,
) => {
  if (!orbsContainerEl || !agentsContainerEl) return

  // Reset orb positions and opacity
  const orbs = orbsContainerEl.querySelectorAll("div")
  orbs.forEach((orb) => {
    orb.style.transform = "translate(0, 0)"
    orb.style.opacity = "0"
  })

  // Reset agent positions and opacity
  const agents = agentsContainerEl.querySelectorAll("div")
  agents.forEach((agent) => {
    agent.style.opacity = "0"
  })
}
